import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.assign.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Animate from '../../wui-animate/src';
import createChainedFunction from '../../wui-core/src/createChainedFunction';
import ownerDocument from '../../wui-overlay/src/utils/ownerDocument';
import addEventListener from '../../wui-overlay/src/utils/addEventListener';
import classnames from 'classnames';
import Notice from './Notice';
import { WebUI } from "../../wui-core/src/index.js";
var seed = 0;
var now = Date.now();

function getUuid() {
  return "uNotification_".concat(now, "_").concat(seed++);
}

var propTypes = {
  show: PropTypes.bool,
  clsPrefix: PropTypes.string,
  style: PropTypes.object,
  position: PropTypes.oneOf(['topRight', 'bottomRight', 'top', 'bottom', 'topLeft', 'bottomLeft', '']),
  transitionName: PropTypes.string,
  keyboard: PropTypes.bool,
  // 按esc键是否关闭notice
  onEscapeKeyUp: PropTypes.func,
  // 设置esc键特殊钩子函数
  animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
var defaultProps = {
  animation: 'fade',
  keyboard: true,
  position: 'topRight',
  show: false,
  clsPrefix: "",
  transitionName: "",
  onEscapeKeyUp: function onEscapeKeyUp() {}
};
var Notification = (_dec = WebUI({
  name: "notification",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Notification, _Component);

  var _super = _createSuper(Notification);

  function Notification(props) {
    var _this;

    _classCallCheck(this, Notification);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleDocumentKeyUp", function (e) {
      if (_this.props.keyboard && e.keyCode === 27 && _this.state.notices.length) {
        _this.setState(function (previousState) {
          previousState.notices.shift();
          return {
            notices: previousState.notices
          };
        });

        if (_this.props.onEscapeKeyUp) {
          _this.props.onEscapeKeyUp(e);
        }
      }
    });

    _this.state = {
      notices: []
    };
    _this.add = _this.add.bind(_assertThisInitialized(_this));
    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    Notification.clear = _this.clear.bind(_assertThisInitialized(_this));
    Notification.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    Notification.add = _this.add.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Notification, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // 给document绑定keyup事件
      var doc = ownerDocument(this);
      this._onDocumentKeyupListener = addEventListener(doc, 'keyup', this.handleDocumentKeyUp);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._onDocumentKeyupListener.remove();
    }
  }, {
    key: "getTransitionName",
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;

      if (!transitionName && props.animation) {
        transitionName = "".concat(props.clsPrefix, "-").concat(props.animation);
      }

      return transitionName;
    }
  }, {
    key: "add",
    value: function add(notice) {
      var key = notice.key = notice.key || getUuid();
      this.setState(function (previousState) {
        var notices = previousState.notices;

        if (!notices.filter(function (v) {
          return v.key === key;
        }).length) {
          return {
            notices: notices.concat(notice)
          };
        }
      });
    }
  }, {
    key: "remove",
    value: function remove(key) {
      this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose(key) {
      var _self = this;

      if (key && _self.state.notices.length > 0) {
        var newArr = _self.state.notices;
        console.log(newArr.findIndex(function (item) {
          return item.key === key;
        }));
        var keyArr = newArr.map(function (res) {
          return res.key;
        });

        if (keyArr.includes(key)) {
          newArr.splice(newArr.findIndex(function (item) {
            return item.key === key;
          }), 1);
        }

        _self.setState({
          notices: newArr
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _self = this;

      _self.setState({
        notices: []
      });
    }
    /**
     * 处理绑定在document上的keyup事件
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classes;

      var _this$props = this.props,
          clsPrefix = _this$props.clsPrefix,
          className = _this$props.className,
          position = _this$props.position,
          style = _this$props.style;
      var noticeNodes = this.state.notices.map(function (notice) {
        var onClose = createChainedFunction(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return /*#__PURE__*/React.createElement(Notice, _extends({
          clsPrefix: clsPrefix
        }, notice, {
          onClose: onClose
        }), notice.content);
      });
      var classes = (_classes = {}, _defineProperty(_classes, clsPrefix, 1), _defineProperty(_classes, className, !!className), _classes);

      if (position) {
        classes["".concat(clsPrefix, "-").concat(position)] = !!position;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classnames(classes),
        style: style
      }, /*#__PURE__*/React.createElement(Animate, {
        transitionName: this.getTransitionName()
      }, noticeNodes));
    }
  }]);

  return Notification;
}(Component)) || _class);
;
Notification.propTypes = propTypes;

Notification.newInstance = function newNotificationInstance(properties, callback) {
  if (typeof callback !== 'function') {
    console.error('You must introduce callback as the second parameter of Notification.newInstance().');
    return;
  }

  var props = properties || {};
  var container = props.container || document.body;

  if (typeof container == 'function') {
    container = container();
  }

  var div = document.createElement('div');
  container.appendChild(div);
  var called = false;

  function ref(notification) {
    if (called) {
      return;
    }

    called = true;
    callback({
      notice: function notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key) {
        notification.remove(key);
      },
      component: notification,
      destroy: function destroy() {
        ReactDOM.unmountComponentAtNode(div);
        container.removeChild(div);
      }
    });
  }

  ReactDOM.render( /*#__PURE__*/React.createElement(Notification, _extends({}, props, {
    ref: ref
  })), div);
};

Notification.success = function (properties) {
  Notification.add(Object.assign(properties, {
    color: 'success'
  }));
};

Notification.info = function (properties) {
  Notification.add(Object.assign(properties, {
    color: 'info'
  }));
};

Notification.warning = function (properties) {
  Notification.add(Object.assign(properties, {
    color: 'warning'
  }));
};

Notification.warn = function (properties) {
  Notification.add(Object.assign(properties, {
    color: 'warning'
  }));
};

Notification.error = function (properties) {
  Notification.add(Object.assign(properties, {
    color: 'danger'
  }));
};

Notification.open = function (properties) {
  Notification.add(properties);
};

Notification.close = function (properties) {
  Notification.handleClose(properties);
};

Notification.destroy = function () {
  Notification.clear();
};

export default Notification;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-notification/src/Notification.js